import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { IDeleteApiResponse, IError } from "../../utils/api.types";

import {
    IDocumentTypeResponse,
    IDocumentTypes,
    IDocumentType
} from "../../utils/documentType.types";

/**
 * Fetch currencies async thunk.
*/
export const fetchDocumentTypes = createAsyncThunk(
    'documentType/fetchDocumentTypes',
    async (): Promise<IDocumentType[]> => {
        const response = await axios.get(`/api/v1/document-types`);
        return response.data.documentTypes;
    }
);

